import { useParams } from 'react-router-dom';

import { PCFooter } from '@commonPackage/components';
import { MetaConfig } from '@portalCommon/components';
import { RouterConfigEnum, EnumCaseTypes } from '@portalCommon/constants';

import classnames from 'classnames/bind';
import { Back2Top, Contact, ContactBox, NavHeader, Consult } from '@/components';
import { ArtShow } from './pages/ArtShow';
import { CarShow } from './pages/CarShow';
import { IndustrySubmmit } from './pages/IndustrySubmmit';
import { Learning } from './pages/Learning';
import { Museum } from './pages/museum';

import CorporateSpace from './pages/corporateSpace';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const renderMap = new Map([
  [EnumCaseTypes.Learning, <Learning key={EnumCaseTypes.Learning} type={EnumCaseTypes.Learning} />],
  [EnumCaseTypes.CarShow, <CarShow key={EnumCaseTypes.CarShow} type={EnumCaseTypes.CarShow} />],
  [EnumCaseTypes.ArtShow, <ArtShow key={EnumCaseTypes.ArtShow} type={EnumCaseTypes.ArtShow} />],
  [
    EnumCaseTypes.IndustrySummit,
    <IndustrySubmmit key={EnumCaseTypes.IndustrySummit} type={EnumCaseTypes.IndustrySummit} />,
  ],
  [EnumCaseTypes.CorporateSpace, <CorporateSpace key={EnumCaseTypes.CorporateSpace} />],
  [EnumCaseTypes.Museum, <Museum key={EnumCaseTypes.Museum} />],
]);
const SceneCase = () => {
  const { id } = useParams<{ id: string }>();
  return (
    <>
      <MetaConfig routerPath={`${RouterConfigEnum.SceneCase}-${id}`} />
      <NavHeader isStatic mode="white" />
      <div className={cx('scene-case-page')}>{renderMap.get(id as EnumCaseTypes)}</div>
      {![EnumCaseTypes.CorporateSpace, EnumCaseTypes.Museum].includes(id as EnumCaseTypes) && (
        <Consult routerPath={RouterConfigEnum.SceneCase} />
      )}
      <Contact />
      <PCFooter isMain={import.meta.env.VITE_MAIN === 'true'} />
      <ContactBox />
      <Back2Top />
    </>
  );
};
export default SceneCase;
